<div class="apps d-flex justify-content-between align-items-center">
  <h3> APPS </h3>
  <app-switch-toggle-checkbox [isOn]="applications.appsenabled" (isOnChange)="applications.appsenabled = $event"></app-switch-toggle-checkbox>
</div>
<div class="collapse" [ngClass]="{'show': applications.appsenabled}">
  <app-form-check *ngIf="admin" [isAppChecked]="applications.youtube" [appName]="'youtube'" (isOnChange)="setApplication($event, 'youtube')"></app-form-check>
  <app-form-check [isAppChecked]="applications.browser" [appName]="'browser'" (isOnChange)="setApplication($event, 'browser')"></app-form-check>
  <app-form-check [isAppChecked]="applications.netflix" [appName]="'netflix'" (isOnChange)="setApplication($event, 'netflix')"></app-form-check>
  <app-form-check [isAppChecked]="applications.dazn" [appName]="'dazn'" (isOnChange)="setApplication($event, 'dazn')"></app-form-check>
</div>
